import React, { createContext, useState, useContext } from 'react'
import { RequestedLayerLinkSession } from 'generated/types'

export type PlaidLayerContextType = {
  plaidLayerData: RequestedLayerLinkSession | null
  setPlaidLayerData: React.Dispatch<React.SetStateAction<RequestedLayerLinkSession | null>>
  errorLocation: string | null
  setErrorLocation: React.Dispatch<React.SetStateAction<string | null>>
}

export const PlaidLayerContext = createContext<PlaidLayerContextType | null>(null)

export const PlaidLayerProvider = ({ children }) => {
  const [plaidLayerData, setPlaidLayerData] = useState(null)
  const [errorLocation, setErrorLocation] = useState(null)
  return (
    <PlaidLayerContext.Provider
      value={{
        plaidLayerData,
        setPlaidLayerData,
        errorLocation,
        setErrorLocation,
      }}
    >
      {children}
    </PlaidLayerContext.Provider>
  )
}

export const usePlaidLayerData = () => useContext(PlaidLayerContext)
